import React, { lazy } from 'react'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { RootState } from '../store'

const Landing = lazy(() => import('../pages/Landing'))
const Dashboard = lazy(() => import('../pages/Dashboard'))

/**
 * `/` = marketing landing for guests, full dashboard for signed-in users
 * (same UI as `/dashboard`).
 */
const RootRoute: React.FC = () => {
  const { isAuthenticated, isLoading } = useSelector((state: RootState) => state.auth)
  const [searchParams] = useSearchParams()
  // `/?guest=1` always shows the marketing hero (used by the /promo recorder iframe).
  const forceGuest = searchParams.get('guest') === '1'

  if (forceGuest) {
    return <Landing forceGuest />
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" />
      </div>
    )
  }

  return isAuthenticated ? <Dashboard /> : <Landing />
}

export default RootRoute
